










































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import api from '@/libs/api';
import { DisbursementMerchantBalanceResponse, DetailPricingDisbursementResponse } from '@/libs/api.interfaces';
import AddIcon from 'mdi-vue/Plus';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import Button from '@/components/Button.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import format from '@/libs/numberFormat';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/Modal.vue';
import Select from '@/components/Select.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Select2 from '@/components/Select2.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import CloseIcon from 'mdi-vue/Close';
import Checkbox from '@/components/Checkbox.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import BussinessBalanceBox from './components/BusinessBalanceBox.vue';

// extend('greater', {
//   params: ['target'],
//   validate(value, { target }) {
//     let vInt = 0;
//     let tarInt = 0;
//     try {
//       vInt = parseInt(value, 10);
//       tarInt = parseInt(target, 10);
//     } catch (err) {
//       console.error(err);
//     }
//     if (vInt <= tarInt) {
//       return false;
//     }
//     return true;
//   },
//   message: 'Maximum amount must be great than minimum amount',
// });

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    BussinessBalanceBox,
    ScrollbarWrapper,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    CloseIcon,
    AddIcon,
    Button,
    Modal,
    Select,
    Select2,
    FormInput,
    Toggle,
    ActionPopup,
    Checkbox,
    StatusIndicator,
    Loader,
    ValidationObserver,
    ExportIcon,
    SearchIcon,
    SearchRow,
    SearchField,
  },
  methods: {
    format,
  },
})
export default class BussinessDetail extends Vue {
  loading = true;
  loadingTable = true;
  loadingListBank = true;
  loadingPopup = false;
  loadingExport = false;
  loadingEdit = false;
  balance = 0;
  selectedType = 'Normal';
  feeSharing = '';
  id = '';
  status = false;
  name = 'Balance';
  dataTier = [{
    min: '',
    max: '',
    type: '',
    price: '',
    feeSharing: false,
    fee: '',
  }]

  statusPaymentChannel: LabelValue[] = [
    {
      label: 'ACTIVE',
      value: 'ACTIVE',
    },
    {
      label: 'INACTIVE',
      value: 'INACTIVE',
    },
  ];

  selectedStatusPaymentChannel: LabelValue | null = null;

  searchOpen = false;

  listBankFilter = [{ id: '', label: '' }];

  filterBank: LabelValue | null = null;

  order = '';
  description = '';
  dataTable: any[] = [];
  listBank = [{ id: '', label: '', code: '' }];
  showModal = false;
  selectedBank: { id: string; label: string; code: string }[] = [];
  merchantCode = '';

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  }

  format!: (val: number) => string;

  printFeeSharing(pricing: { fee_sharing: string; fee_type: string; price: string; is_sharing: boolean }) {
    console.log(pricing, this);
    if (pricing.fee_type === '') {
      return '-';
    }
    if (pricing.fee_type === 'MDR') {
      const price = Number(pricing.price);
      const feeSharing = Number(pricing.fee_sharing);
      return `Rp${(price / 100) * feeSharing}`;
    }
    return `Rp${pricing.fee_sharing}`;
  }

  async created() {
    await this.getBalance();
    this.getPricing(false);
    this.getBankList();
    this.clearData();
  }

  async getBalance() {
    try {
      const { data } = await api.get<DisbursementMerchantBalanceResponse>('/prepaid/merchant/balance', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_id: this.$route.params.id,
        },
      });

      const merchant = data.data[0];
      this.name = merchant.name;
      // this.balance = merchant.histories ? Number(merchant.histories.balance) : 0;
      this.balance = data.totalBalance;
      this.merchantCode = merchant.merchant_code;
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getPricing(exp: boolean) {
    try {
      const { data } = await api.get('/disbursement/pricing', {
        params: {
          merchant_code: this.merchantCode,
          export: exp ? true : undefined,
        },
      });

      if (exp) {
        this.loadingTable = false;
        const downloadData = data as unknown as { path: string };
        return downloadData.path;
      }

      const dataTable = data.data;
      this.dataTable = dataTable;
      this.loadingTable = false;

      return null;
    } catch (err) {
      console.error(err);

      return null;
    }
  }

  async exportPricing() {
    this.loadingExport = true;
    if (this.filterBank !== null) {
      showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

      try {
        const path = await this.getPricing(true);
        // this.downloadSheet(path as string);
        console.log(path);
        showToast(ToastType.SUCCESS, 'Success', 'Export merchant account state success');
      } catch (err) {
        showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to download sheet');
      }
    } else {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Please select business first');
    }
    this.loadingExport = false;
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(url: string) {
    const fileLink = document.createElement('a');
    fileLink.href = `${process.env.VUE_APP_API_URL}${url}`;
    fileLink.setAttribute('download', 'report.xlsx');

    document.body.appendChild(fileLink);
    fileLink.click();
  }

  async toggleModal(val: string) {
    await this.getBankList();

    this.showModal = !this.showModal;
    this.order = val;
  }

  closeModal() {
    this.clearData();
    this.showModal = false;
  }

  async toggleSearchOpen() {
    try {
      const { data } = await api.get('/disbursement/bank/partner');
      this.listBankFilter = data.map((e: any) => ({ id: e.id, label: e.name, code: e.code }));
      this.loadingListBank = false;
    } catch (err) {
      console.error(err);
    }
    this.searchOpen = !this.searchOpen;
  }

  async addPricing() {
    this.loading = true;

    try {
      await api.post('/disbursement/pricing', {
        id_payment_channel: this.selectedBank.map((item) => item.code),
        pricing: this.dataTier.map((e: {
          min: string;
          max: string;
          type: string;
          price: string;
          feeSharing: boolean;
          fee: string;
        }) => ({
          min_amount: e.min,
          max_amount: e.max,
          price: e.price,
          is_sharing: e.feeSharing === true ? 1 : 0,
          fee_type: e.type,
          fee_sharing: e.fee,
        })),
        description: this.description,
        status: this.status ? 'ACTIVE' : 'INACTIVE',
        merchant_code: this.merchantCode,
      });

      this.getPricing(false);
      this.closeModal();

      showToast(ToastType.SUCCESS, 'Success', 'Add Pricing');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to add pricing');
      this.loading = false;
    }
  }

  async editPricing() {
    this.loadingEdit = true;

    try {
      await api.put('/disbursement/pricing', {
        id_payment_channel: this.selectedBank[0].code,
        id: this.id,
        pricing: this.dataTier.map((e: any) => ({
          min_amount: e.min,
          max_amount: e.max,
          price: e.price,
          is_sharing: e.feeSharing === true ? 1 : 0,
          fee_type: e.type,
          fee_sharing: e.fee,
        })),
        description: this.description,
        status: this.status ? 'ACTIVE' : 'INACTIVE',
        merchant_code: this.merchantCode,
      });

      this.closeModal();
      this.getPricing(false);

      showToast(ToastType.SUCCESS, 'Success', 'Update pricing');
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to update pricing');
    }

    this.loadingEdit = false;
  }

  async getBankList() {
    try {
      const { data } = await api.get<{
        id: number;
        code: string;
        name: string;
      }[]>('/disbursement/list/bank', {
        params: {
          merchant_code: this.merchantCode,
        },
      });

      this.listBank = data.map((e: {
        id: number;
        code: string;
        name: string;
      }) => ({ id: e.id.toString(), label: e.name, code: e.code }));

      this.loadingListBank = false;
    } catch (err) {
      console.error(err);
    }
  }

  async openDetail(id: string) {
    try {
      this.loadingPopup = true;
      const { data } = await api.get<DetailPricingDisbursementResponse>('/disbursement/pricing', {
        params: {
          id,
        },
      });
      this.selectedBank[0] = {
        id: data.bank.code,
        label: data.bank.name,
        code: data.bank.code,
      };

      this.dataTier = data.pricing.map((e: {
        fee_sharing: string;
        is_sharing: number;
        min_amount: string;
        max_amount: string;
        price: string;
        fee_type: string;
      }) => ({
        min: e.min_amount.toString(),
        max: e.max_amount.toString(),
        type: e.fee_type,
        price: e.price.toString(),
        feeSharing: e.is_sharing === 1,
        fee: e.fee_sharing.toString(),
      }));
      this.id = data.id.toString();
      this.description = data.description;
      this.status = data.status === 'ACTIVE';
      this.loadingPopup = false;
      this.loadingListBank = false;
      this.toggleModal('edit');
    } catch (err) {
      console.error(err);
    }
  }

  deleteTier(index: number) {
    const current = this.dataTier.slice();
    current.splice(index, 1);
    this.dataTier = current;
  }

  addTier() {
    this.dataTier.push({
      min: '',
      max: '',
      type: '',
      price: '',
      feeSharing: false,
      fee: '',
    });
  }

  clearData() {
    this.selectedBank = [];
    this.dataTier = [{
      min: '',
      max: '',
      type: '',
      price: '',
      feeSharing: false,
      fee: '',
    }];
    this.id = '';
    this.description = '';
    this.status = false;
  }
}

